import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {State} from '../index';
import {Injectable} from '@angular/core';
import {catchError, debounceTime, filter, map, mergeMap, tap, throttleTime, withLatestFrom} from 'rxjs/operators';

import * as notes from './index';
import {ToastrService} from 'ngx-toastr';
import {of} from 'rxjs';

const notesKeyPrefix = 'olc-notes-';

@Injectable()
export class NotesEffects {
	saveNoteToStorage$ = createEffect(() => this.actions$.pipe(
		ofType(notes.saveNotes),
		debounceTime(2000),
		tap(action => {
			this.store.dispatch(notes.startSaving());
			localStorage.setItem(notesKeyPrefix + action.lectureId, action.noteContent);
		})
	), {dispatch: false});

	getNoteFromStorage$ = createEffect(() => this.actions$.pipe(
		ofType(notes.getNotes),
		//throttleTime(30000), //only allow every 30s (screws things up since it will swallow calls for independent notes)
		filter(action => !!action.lectureId),
		mergeMap(action => {
			console.log('looking for lecture notes', action.lectureId);
			const note = localStorage.getItem(notesKeyPrefix + action.lectureId);
			return of(notes.getNotesComplete({courseId: action.courseId, lectureId: action.lectureId, noteContent: note || ''}));
		})
	));

	constructor(
		private actions$: Actions,
		private store: Store<State>,
		private toastr: ToastrService,
	) {

	}
}

